(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode("")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as l, jsxs as r, Fragment as I } from "react/jsx-runtime";
import C from "clsx";
import { MDBBtn as z, MDBIcon as L } from "mdb-react-ui-kit";
import { useState as M, useMemo as ee, useRef as S, useEffect as D } from "react";
const K = {
  G: 1e9,
  M: 1e6,
  K: 1e3,
  B: 1
}, le = (a) => {
  const t = parseFloat(a), f = a[a.length - 1], p = K[f];
  return t * p;
}, ie = (a, t) => t < a.size ? K.M : null, se = (a, t) => {
  if (t.length) {
    const f = a.type.split("/")[0], p = a.type.split("/")[1];
    let c = !1;
    return t.forEach((n) => {
      (n.includes("/*") && n.includes(f) || n.includes("/") && n.includes(f) && n.includes(p) || n.includes(p)) && (c = !0);
    }), c;
  }
  return !0;
}, ae = {
  acceptedExtensions: []
}, de = ({
  acceptedExtensions: a = ae.acceptedExtensions,
  className: t,
  defaultMessage: f = "Drag and drop a file here or click",
  defaultFile: p,
  files: c,
  disabled: n,
  disabledRemoveButton: Y,
  formatError: U = "Your file has incorrect file format (correct format(s) ~~~)",
  getInputFiles: F,
  fileUploadRef: j,
  maxFileSize: T = 1 / 0,
  mainError: O = "Ooops, something wrong happended.",
  maxFileQuantity: _ = 0,
  maxSizeError: b = "Your file is too big (Max size ~~~)",
  multiple: N = !1,
  onRemove: m,
  onChange: d,
  ...R
}) => {
  const [g, k] = M([]), [x, v] = M([]), s = ee(() => c !== void 0 ? c : x, [c, x]), [h, G] = M(p), [$, y] = M([]), q = S(null), H = j || q, J = S(null), w = S(null), P = C(
    "file-upload",
    n && "disabled",
    s.length > 0 && "has-preview",
    g.length > 0 && "has-error",
    t
  ), V = (e) => {
    if (e.target.files.length === 0)
      return;
    h && G(null);
    const i = Array.from(e.target.files);
    if (N) {
      if (s.length === _ && _)
        return;
      y([]), v([...s, i[0]]), d && d([...s, i[0]]);
    } else
      v(i), d && d(i);
  };
  D(() => {
    F && F(s);
  }, [s, F]), D(() => {
    c != null && (c.length === 0 || !c) && w.current && (w.current.value = "");
  }, [c]), D(() => {
    if (s.length > 0) {
      let e = T, i = [];
      T !== 1 / 0 && (e = le(T)), typeof a == "string" && (i = a.split(",")), s.forEach((u) => {
        const o = ie(u, e), E = se(u, i);
        o && k((A) => [
          ...A,
          b.replace("~~~", `${e / o}M`)
        ]), E || k((A) => [
          ...A,
          U.replace("~~~", a)
        ]), !o && E && k([]);
      });
    }
  }, [a, s, U, T, b]), D(() => {
    g.length > 0 && v([]);
  }, [g]), D(() => {
    var e;
    s.length > 0 && ((e = s[0].type) == null ? void 0 : e.split("/"))[0] === "image" && s.forEach((u) => {
      const o = new FileReader();
      o.readAsDataURL(u), o.onloadend = () => {
        y(N ? (E) => [...E, o.result] : [o.result]);
      };
    });
  }, [s, N]);
  const W = (e) => {
    if (N) {
      const i = s.filter((u) => u !== e);
      y([]), v(i), d && d(i);
    } else if (v([]), y([]), d && d([]), w.current) {
      const i = w.current;
      i.value = "";
    }
  }, B = () => {
    if (h) {
      const e = h.split("/"), i = e[e.length - 1];
      return i.split(".")[i.split(".").length - 1];
    }
  }, X = () => {
    if (h) {
      const e = h.split("/");
      return e[e.length - 1];
    }
  }, Z = (e) => {
    m == null || m(), W(e);
  }, Q = () => {
    m == null || m(), G(null);
  };
  return /* @__PURE__ */ l("div", { className: "file-upload-wrapper", children: /* @__PURE__ */ r("div", { className: P, ref: H, ...R, children: [
    /* @__PURE__ */ r("div", { className: "file-upload-message", children: [
      /* @__PURE__ */ l("i", { className: "fas fa-cloud-upload-alt file-upload-cloud-icon" }),
      /* @__PURE__ */ l("p", { className: "file-upload-default-message", children: f }),
      /* @__PURE__ */ l("p", { className: "file-upload-main-error", children: g.length > 0 && /* @__PURE__ */ l(I, { children: O }) })
    ] }),
    /* @__PURE__ */ l("div", { className: "file-upload-mask" }),
    /* @__PURE__ */ l("ul", { className: "file-upload-errors", children: g.map((e, i) => /* @__PURE__ */ l("li", { className: "file-upload-error", children: e }, i)) }),
    /* @__PURE__ */ l(
      "input",
      {
        onInput: V,
        multiple: N,
        type: "file",
        className: "file-upload-input",
        accept: a,
        ref: w
      }
    ),
    /* @__PURE__ */ r("div", { className: "file-upload-previews", ref: J, children: [
      h && /* @__PURE__ */ r("div", { className: "file-upload-preview", children: [
        /* @__PURE__ */ l("div", { className: "file-upload-render", children: B() === "jpg" || B() === "jpeg" || B() === "png" || B() === "svg" ? /* @__PURE__ */ l("img", { src: p, alt: "", className: "file-upload-preview-img" }) : /* @__PURE__ */ r(I, { children: [
          /* @__PURE__ */ l("i", { className: "fas fa-file file-upload-file-icon" }),
          /* @__PURE__ */ l("span", { className: "file-upload-extension" })
        ] }) }),
        /* @__PURE__ */ r("div", { className: "file-upload-preview-details", children: [
          !Y && /* @__PURE__ */ r(z, { onClick: Q, color: "danger", className: "file-upload-remove-file-btn", children: [
            "Remove ",
            /* @__PURE__ */ l(L, { far: !0, icon: "trash-alt", className: "ms-1" })
          ] }),
          /* @__PURE__ */ l("div", { className: "file-upload-details-container", children: /* @__PURE__ */ r("div", { className: "file-uplod-preview-details-inner", children: [
            /* @__PURE__ */ l("p", { className: "file-upload-file-name", children: X() }),
            /* @__PURE__ */ l("p", { className: "file-upload-preview-message", children: "Drag and drop or click to replace" })
          ] }) })
        ] })
      ] }),
      s.map((e, i) => /* @__PURE__ */ r("div", { className: "file-upload-preview", children: [
        /* @__PURE__ */ l("div", { className: "file-upload-render", children: e.type.split("/")[0] === "image" ? /* @__PURE__ */ l("img", { src: $[i], alt: "", className: "file-upload-preview-img" }) : /* @__PURE__ */ r(I, { children: [
          /* @__PURE__ */ l("i", { className: "fas fa-file file-upload-file-icon" }),
          /* @__PURE__ */ l("span", { className: "file-upload-extension", children: e.type.split("/")[1] })
        ] }) }),
        /* @__PURE__ */ r("div", { className: "file-upload-preview-details", children: [
          !Y && /* @__PURE__ */ r(z, { onClick: () => Z(e), color: "danger", className: "file-upload-remove-file-btn", children: [
            "Remove ",
            /* @__PURE__ */ l(L, { far: !0, icon: "trash-alt", className: "ms-1" })
          ] }),
          /* @__PURE__ */ l("div", { className: "file-upload-details-container", children: /* @__PURE__ */ r("div", { className: "file-uplod-preview-details-inner", children: [
            /* @__PURE__ */ l("p", { className: "file-upload-file-name", children: e.name }),
            /* @__PURE__ */ l("p", { className: "file-upload-preview-message", children: "Drag and drop or click to replace" })
          ] }) })
        ] })
      ] }, i))
    ] })
  ] }) });
};
export {
  de as MDBFileUpload
};
